import { Check } from "lucide-react";

const groups = [
  {
    title: "Kitchens",
    items: [
      "Counters, sinks & backsplash",
      "Cabinet exteriors wiped",
      "Stovetop & microwave",
      "Interior appliances (on request)",
    ],
  },
  {
    title: "Bathrooms",
    items: [
      "Tubs, showers & tile",
      "Toilets sanitized",
      "Mirrors & glass",
      "Floors mopped",
    ],
  },
  {
    title: "Living Areas & Bedrooms",
    items: [
      "Dusting all reachable surfaces",
      "Vacuuming carpets & rugs",
      "Floors mopped & polished",
      "Baseboards (on request)",
    ],
  },
  {
    title: "High-Touch & Trash",
    items: [
      "Light switches & handles",
      "Door knobs & remotes",
      "Trash removal & liners replaced",
      "Sanitizing high-touch areas",
    ],
  },
  {
    title: "Move-In / Move-Out",
    items: [
      "Inside cabinets & drawers",
      "Inside oven & fridge",
      "Window sills & tracks",
      "Detailed corner-to-corner clean",
    ],
  },
  {
    title: "Office, Church & Commercial",
    items: [
      "Common areas & lobbies",
      "Restrooms sanitized",
      "Pews, classrooms & break rooms",
      "Floors, glass & trash service",
    ],
  },
];

export default function ServiceDetails() {
  return (
    <section className="section">
      <div className="container-ss">
        <div className="max-w-2xl">
          <span className="pill mb-3">What's Included</span>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            A clean that touches <span className="text-[#1E3A8A]">every detail</span>
          </h2>
          <p className="text-slate-600 mt-3">
            What's included can be customized to your space. Here's what most of our cleans cover.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {groups.map((g) => (
            <div key={g.title} className="ss-card p-6" data-testid={`detail-${g.title.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              <h3 className="font-display text-lg font-semibold text-slate-900">{g.title}</h3>
              <ul className="mt-3 space-y-2">
                {g.items.map((it) => (
                  <li key={it} className="flex items-start gap-2 text-sm text-slate-600">
                    <span className="mt-0.5 h-5 w-5 rounded-full bg-sky-100 text-[#1E3A8A] inline-flex items-center justify-center">
                      <Check size={12} />
                    </span>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="mt-8 text-sm text-slate-500 italic">
          * Final pricing depends on the size, condition, frequency and scope of the cleaning.
        </p>
      </div>
    </section>
  );
}
